import { render, staticRenderFns } from "./yudo_it_other.vue?vue&type=template&id=0f8f90fe&scoped=true&"
import script from "./yudo_it_other.vue?vue&type=script&lang=js&"
export * from "./yudo_it_other.vue?vue&type=script&lang=js&"
import style0 from "./yudo_it_other.vue?vue&type=style&index=0&id=0f8f90fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f90fe",
  null
  
)

export default component.exports